import React from "react";
import { Skeleton } from "@mui/material";
import styles from "../../PaymentSummarySection.module.scss";

export const BillItemShimmer = ({
    isFetched,
    fetchedJSX,
    overrideClassName,
}: {
    isFetched?: boolean;
    fetchedJSX: JSX.Element | string | number;
    overrideClassName?: string;
}) => {
    return isFetched ? (
        <>{fetchedJSX}</>
    ) : (
        <Skeleton
            variant="rectangular"
            className={overrideClassName || styles.headerShimmer}
        />
    );
};

BillItemShimmer.defaultProps = {
    isFetched: false,
    overrideClassName: undefined,
};
